import React, { useEffect, useReducer } from 'react';
import { Box, InputAdornment, TextField, CircularProgress, Typography } from '@mui/material';
import { FixedSizeList } from 'react-window';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import SearchIcon from '@mui/icons-material/Search';
import { exitTheme } from '../../hookState/ThemeState';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import RouteConstants from '../../constants/routeConstants';
import ProfileInitial from '../../sharedcomponents/profile/profileInitial';

const initialState = {
    users: [],
    searchUser: '',
    loading: false,
    userList: [],
    modifiedList: [],
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_LOADING':
            return { ...state, loading: action.payload };
        case 'SET_USERS':
            return { ...state, users: action.payload, userList: action.payload, modifiedList: action.payload };
        case 'SET_SEARCH_USER':
            return { ...state, searchUser: action.payload };
        case 'SET_MODIFIED_LIST':
            return { ...state, modifiedList: action.payload };
        default:
            return state;
    }
};

const ChangeUser = () => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const getUsersList = () => {
        dispatch({ type: 'SET_LOADING', payload: true });
        ApiHelper.get(APIURLConstants.GET_USERS_LIST)
            .then((res) => {
                dispatch({ type: 'SET_USERS', payload: res.data });
                dispatch({ type: 'SET_LOADING', payload: false });
                dispatch({ type: 'SET_MODIFIED_LIST', payload: res.data });
            })
            .catch((error) => {
                dispatch({ type: 'SET_LOADING', payload: false });
                if (error.response && error.response.status === 401) {
                    alert(error);
                }
            });
    };

    useEffect(() => {
        getUsersList();
        exitTheme();
    }, []);

    const onHandleChange = (e) => {
        const searchValue = e.target.value;
        dispatch({ type: 'SET_SEARCH_USER', payload: searchValue });

        if (searchValue) {
            const filterStore = state.userList.filter(user =>
                user.name.toLowerCase().indexOf(searchValue.toLowerCase()) > -1
            );
            dispatch({ type: 'SET_MODIFIED_LIST', payload: filterStore });
        } else {
            dispatch({ type: 'SET_MODIFIED_LIST', payload: state.userList });
        }
    };

    const handleClick = (user) => {
        Helper.setStorage('userInfo', user);
        const getURL = APIURLConstants.SET_USER_AS(user.userID);

        ApiHelper.get(getURL)
            .then(() => {
                window.location.href = RouteConstants.DASHBOARD;
            })
            .catch((err) => {
                if (err.response && err.response.status === 401) {
                    console.log(err);
                }
            });
    };

    const renderRow = ({ index, style }) => {
        const firstUser = state.modifiedList[index * 2];
        const secondUser = state.modifiedList[index * 2 + 1];

        return (
            <div style={style} key={index}>
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '10px',
                        marginBottom:'10px'
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            padding: '16px', 
                            backgroundColor: 'white', 
                            borderRadius: '4px',
                            boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12)',
                            cursor: 'pointer',
                        }}
                        onClick={() => handleClick(firstUser)}
                    >
                        <ProfileInitial data={firstUser} navigationScreen={'changeUser'} />
                        <LockOpenIcon
                            sx={{
                                color: '#17408B',
                                fontSize: 20,
                                marginLeft: 'auto',
                            }}
                        />
                    </Box>

                    {secondUser ? (
                        <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            padding: '16px', 
                            backgroundColor: 'white', 
                            borderRadius: '4px',
                            boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12)', 
                            cursor: 'pointer',
                            marginRight:'10px',
                        }}
                            onClick={() => handleClick(secondUser)}
                        >
                            <ProfileInitial data={secondUser} navigationScreen={'changeUser'} />
                            <LockOpenIcon
                                sx={{
                                    color: '#17408B',
                                    fontSize: 20,
                                    marginLeft: 'auto',
                                }}
                            />
                        </Box>
                    ) : (
                        <Box />
                    )}
                </Box>
            </div>
        );
    };

    return (
        <>
            {state.loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%',width:'100%' }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Box className='contentBox'>
                    {state.users.length > 0 && (
                        <Box
                            sx={{
                                '& > :not(style)': {
                                    m: 1,
                                    height: 40,
                                    width: '35ch',
                                    marginTop: '8px',
                                },
                            }}
                            noValidate
                            autoComplete="off">
                            <TextField
                                id="search"
                                size="small"
                                label="Search User"
                                value={state.searchUser}
                                onChange={onHandleChange}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <SearchIcon sx={{ fontSize: 20 }} />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                    )}
                    <Box
                        sx={{
                            p: 1,
                            display: 'grid',
                            gridTemplateColumns: '1fr',
                        }}
                    >
                        {state.modifiedList.length > 0 ? (
                            <FixedSizeList
                                height={790} 
                                width={'100%'}
                                itemSize={80} 
                                itemCount={Math.ceil(state.modifiedList.length / 2)} 
                            >
                                {renderRow}
                            </FixedSizeList>
                        ) : (
                            <Typography sx={{ textAlign: 'center' }} variant="body2">
                                {state.searchUser ? 'No Data Found' : 'Data Not Found'}
                            </Typography>
                        )}
                    </Box>
                </Box>
            )}
        </>
    );
};

export default {
    routeProps: {
        path: RouteConstants.CHANGE_USER,
        component: React.memo(ChangeUser),
    },
    name: 'ChangeUser',
};
